import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-383475ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "event" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "UPCOMING EVENTS", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, reactive } from 'vue'
    import PageHeader from '@/components/wap/PageHeader-wap.vue';
    import CarouselComponent from '@/components/CarouselComponent.vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'WapEventView',
  setup(__props) {

    const img = reactive([
        {
        title:'Upcoming FREE Information Seminars in the Philippines',
        data:[
            {
            desc:'<b>Baguio City&nbsp&nbsp&nbsp16 January 2024</b>',
            src:'All - FLYER AGRI. BAGUIO.png'
            },
            {
            desc:'<b>Zamboangs City&nbsp&nbsp&nbsp20 January 2024</b>',
            src:'All - FLYER AGRI. ZAMB.png'
            }
        ]
        }
    ]);


    const data = reactive(
      {
        img:img,
        rootPath:'/education',
        root:'Education',
        current:'event',
        currentPath:'/event-wap',
        inquiryPath:'/contact-wap',
        isPara:false,
        isTable:false,
        isCarousel:true
      }
    );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(PageHeader, { value: data }, null, 8, ["value"]),
    _hoisted_3
  ]))
}
}

})